<script lang="ts">
  import * as Accordion from '$lib/components/ui/accordion/index';
  import { Textarea } from '$lib/components/ui/textarea/index';
  import { roastNotes } from '$lib/State.svelte';

  let { disabled = $bindable() } = $props();
</script>

<Accordion.Root type="single">
  <Accordion.Item value="item-1" class="border-b-0">
    <Accordion.Trigger>Notes</Accordion.Trigger>
    <Accordion.Content>
      <Textarea placeholder="Roast notes..." {disabled} bind:value={roastNotes.current} />
    </Accordion.Content>
  </Accordion.Item>
</Accordion.Root>
